var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Recipe',{attrs:{"recipe":_vm.recipe,"buttonLoading":_vm.buttonLoading},on:{"saveRecipe":_vm.saveRecipe}})
}
var staticRenderFns = []

export { render, staticRenderFns }